export default {"src":"/_next/static/media/reading-card.mono.cb727ab7.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};